import React from 'react';
import { Offcanvas, Table } from 'react-bootstrap';

import SubtleBadge from 'components/common/SubtleBadge';

import { getShipmentBadgeColor } from 'constants/shipment';

const PicklistShipmentDetailPanel = ({ show, onHide, shipmentDetail }) => {
  if (!shipmentDetail) return null;

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="end"
      style={{ width: '70vw' }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Shipment Details</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0">
        <div className="bg-light p-3 d-flex">
          <div className="flex-1">
            <small className="text-muted fw-semibold">Shipment Code</small>
            <div className="d-flex align-items-center gap-2">
              <span className="fs-10">{shipmentDetail.shipment_code}</span>
              <SubtleBadge
                bg={getShipmentBadgeColor(shipmentDetail.shipment_status)}
              >
                {shipmentDetail.shipment_status_label}
              </SubtleBadge>
            </div>
          </div>

          <div className="flex-1">
            <small className="text-muted fw-semibold">Sale Order Code</small>
            <div className="fs-10">
              {shipmentDetail.order?.channel_order_id}
            </div>
          </div>

          <div className="flex-1">
            <small className="text-muted fw-semibold">Channel</small>
            <div className="fs-10">
              {shipmentDetail.order?.channel?.channel_type}
            </div>
          </div>
        </div>

        <div className="p-3 d-flex">
          <div className="flex-1">
            <small className="text-muted fw-semibold">Total Quantity</small>
            <div className="fs-10">{shipmentDetail?.total_quantity || 0}</div>
          </div>

          <div className="flex-1">
            <small className="text-muted fw-semibold">
              Weight ({shipmentDetail.weight?.unit || 'g'})
            </small>
            <div className="fs-10">
              {shipmentDetail.weight?.value || '0.00'}
            </div>
          </div>

          <div className="flex-1">
            <small className="text-muted fw-semibold">
              Package Dimensions (mm)
            </small>
            <div className="fs-10">
              {shipmentDetail.package_width || '0.00'} x{' '}
              {shipmentDetail.package_length || '0.00'} x{' '}
              {shipmentDetail.package_height || '0.00'}
            </div>
          </div>
        </div>

        {shipmentDetail?.lines?.length > 0 && (
          <Table size="sm" className="fs-10 overflow-hidden table table-sm">
            <thead className="bg-light">
              <tr>
                <th className="text-nowrap text-start">SKU Code</th>
                <th className="text-nowrap text-start">Name</th>
                <th className="text-nowrap text-start">Barcode</th>
              </tr>
            </thead>
            <tbody>
              {shipmentDetail.lines?.map(line => {
                const product = line.product;

                return (
                  <tr key={product.id}>
                    <td className="text-nowrap text-start">{product.sku}</td>
                    <td className="text-nowrap text-start">{product.name}</td>
                    <td className="text-nowrap text-start">
                      {product?.barcode || '-'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default PicklistShipmentDetailPanel;
